import { getQuotedValueFromHeader } from './getQuotedValueFromHeader';

export function getRealmFromHeader(wwwAuthenticateHeader: string | undefined): string | undefined {
    if (wwwAuthenticateHeader) {
        return getQuotedValueFromHeader(wwwAuthenticateHeader, 'realm');
    }
    return undefined;
}
